(() => {
  const dialog = document.getElementById('by-fit-modal');
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const content = dialog.querySelector('.by-fit-modal__content');
  const scroller = dialog.querySelector('.by-fit-modal__scroll');
  const status = dialog.querySelector('.by-fit-modal__status');
  const error = dialog.querySelector('.by-fit-modal__error');
  const fullGuide = dialog.querySelector('.by-fit-modal__full');
  const closeButton = dialog.querySelector('.by-fit-modal__close');
  const guideUrl = new URL(dialog.dataset.guideUrl || fullGuide.href, window.location.href);
  const prepareLink = link => {
    if (!link || dialog.contains(link)) return false;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return false;
    if (!link.hasAttribute('data-by-fit-trigger') && !/\/pages\/how-to-measure(?:-find-your-fit|-and-find-your-fit)?\/?$/.test(url.pathname)) return false;
    link.href = guideUrl.href;
    link.setAttribute('data-by-fit-trigger', '');
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', dialog.id);
    link.removeAttribute('target');
    return true;
  };
  document.querySelectorAll('a[data-by-fit-trigger],a[href*="/pages/how-to-measure"]').forEach(prepareLink);
  let trigger;
  let savedScroll;
  let savedStyles;
  let loadedUrl;
  let pending;
  let stylePromise;

  const preserve = (element, properties) => properties.map(property => [element, property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)]);
  const lockPage = () => {
    savedScroll = { x: window.scrollX, y: window.scrollY };
    savedStyles = [...preserve(document.body, ['position', 'top', 'left', 'right', 'width', 'overflow', 'padding-right']), ...preserve(document.documentElement, ['overflow', 'scroll-behavior'])];
    const gutter = window.innerWidth - document.documentElement.clientWidth;
    const padding = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
    Object.assign(document.body.style, { position: 'fixed', top: `-${savedScroll.y}px`, left: `-${savedScroll.x}px`, right: '0', width: '100%', overflow: 'hidden' });
    if (gutter > 0) document.body.style.paddingRight = `${padding + gutter}px`;
    document.documentElement.style.overflow = 'hidden';
  };
  const restorePage = () => {
    if (!savedStyles) return;
    const styles = savedStyles;
    savedStyles = null;
    styles.filter(([element, property]) => !(element === document.documentElement && property === 'scroll-behavior')).forEach(([element, property, value, priority]) => {
      if (value) element.style.setProperty(property, value, priority);
      else element.style.removeProperty(property);
    });
    document.documentElement.style.setProperty('scroll-behavior', 'auto', 'important');
    window.scrollTo(savedScroll.x, savedScroll.y);
    const returnTarget = trigger?.isConnected ? trigger : document.querySelector('[data-by-fit-trigger]');
    returnTarget?.focus({ preventScroll: true });
    const [, property, value, priority] = styles.find(([element, property]) => element === document.documentElement && property === 'scroll-behavior');
    if (value) document.documentElement.style.setProperty(property, value, priority);
    else document.documentElement.style.removeProperty(property);
  };
  const loadStyle = () => {
    if (stylePromise) return stylePromise;
    const href = new URL(dialog.dataset.guideStyle, window.location.href).href;
    const existing = [...document.querySelectorAll('link[rel="stylesheet"]')].find(link => link.href === href);
    if (existing?.sheet) return Promise.resolve();
    stylePromise = new Promise((resolve, reject) => {
      const link = existing || document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.addEventListener('load', resolve, { once: true });
      link.addEventListener('error', () => { link.remove(); stylePromise = null; reject(new Error('Guide stylesheet unavailable')); }, { once: true });
      if (!existing) document.head.append(link);
    });
    return stylePromise;
  };
  const loadGuide = url => {
    if (loadedUrl === url.href) return Promise.resolve();
    if (pending) return pending;
    status.hidden = false;
    error.hidden = true;
    content.setAttribute('aria-busy', 'true');
    const endpoint = new URL(url);
    endpoint.searchParams.set('section_id', 'by-fit-guide');
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) endpoint.searchParams.set('preview_theme_id', preview);
    pending = Promise.all([
      fetch(endpoint, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) }).then(response => {
        if (!response.ok) throw new Error('Guide unavailable');
        return response.text();
      }),
      loadStyle()
    ]).then(([html]) => {
      const guide = new DOMParser().parseFromString(html, 'text/html').querySelector('article.by-fit');
      if (!guide || !guide.querySelector('#by-fit-final-title') || guide.querySelectorAll('img').length < 3) throw new Error('Guide incomplete');
      guide.querySelectorAll('script').forEach(script => script.remove());
      guide.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; img.decoding = 'async'; });
      content.replaceChildren(document.importNode(guide, true));
      loadedUrl = url.href;
    }).catch(() => {
      error.hidden = false;
    }).finally(() => {
      status.hidden = true;
      content.setAttribute('aria-busy', 'false');
      pending = null;
    });
    return pending;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!prepareLink(link)) return;
    const url = new URL(guideUrl);
    if (!dialog.open) {
      trigger = link;
      try { dialog.showModal(); } catch (_) { return; }
      lockPage();
      scroller.scrollTop = 0;
      closeButton.focus({ preventScroll: true });
    }
    event.preventDefault();
    fullGuide.href = url.href;
    loadGuide(url);
  }, true);
  closeButton.addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(element => element.getClientRects().length && !element.closest('[hidden]'));
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
  let startedOutside = false;
  dialog.addEventListener('pointerdown', event => { startedOutside = event.target === dialog; });
  dialog.addEventListener('click', event => { if (event.target === dialog && startedOutside) dialog.close(); });
  dialog.addEventListener('close', restorePage);
  dialog.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#by-fit-"]');
    if (!link) return;
    const target = content.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    scroller.scrollTo({ top: target.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 20, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
})();

